/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { setSystemIconLibrary, setupIcons } from '@synergy-design-system/components';

setSystemIconLibrary('sick2025');
setupIcons('sick2025');

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
